export const MODAL_MAX_WIDTH = '900px';

export const SHIMMER_CONTEXT_ROW_COUNT = 6;
export const SHIMMER_STAT_COUNT = 3;
export const SHIMMER_ASSESSMENT_ROW_COUNT = 5;

export const DATE_FORMAT_OPTIONS = Object.freeze({
  month: 'numeric',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  second: '2-digit',
  hour12: true,
});
